/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useImperativeHandle, useEffect, Fragment } from 'react';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { Box, Button } from "@mui/material";
import dayjs from 'dayjs';
import { DeliveryView, DeliveryLinesList, DeliveryChallan } from "./Blocks";
import { Space } from "antd";
import { checkComponentPermission, idNamingConversion, currencyFormat, getColumnWidth, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import { useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { useEventListener } from "../../../../../helpers/useEventListener";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";


export const DeliveryForm = React.forwardRef((props, ref) => {
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { view, orderId, showDetails, type, clsx, history, dispatch, classes, roleManagement } = props;
    const childRef = useRef('');
    const formRef = useRef('');
    const [lines, setLines] = useState([]);
    const [selected, setSelected] = useState([]);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState('lineView');


    const prevEditError = usePrevious(editError);
    const prevEditDetails = usePrevious(editDetails);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) { // Alt + S
            e.preventDefault();
            if (form?.OrderStatus === 'ACCEPTED' && selected?.length > 0) {
                handleSubmit(e);
            }
        }
    }

    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
        };
    }, []);

    const loadTasks = () => {
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
    }

    useEventListener("keydown", handleKeyDown);


    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyStateCheck = emptyValidation('State', form?.stateId, 'dropDown');
        let emptyPincode = emptyValidation('Pincode', form?.pincodeId, 'dropDown');
        let emptyName = emptyValidation('Delivery Name', form?.name);
        setError({});
        if (emptyStateCheck.isValid && emptyName.isValid && emptyPincode.isValid) {
            let a = []; let b = [];

            lines && lines?.length > 0 && lines?.filter((el) => { return selected.find((e) => e === el.id) })?.map((element, i) => {
                return a.push({ ...element });
            });
            lines && lines?.length > 0 && lines?.filter((el) => { return selected.find((e) => e === el.id) })?.map((element, i) => {
                return b.push({ ...element });
            });
            form.salesOrderLineItems = b;
            let subForm = { ...form };
            subForm.salesOrderLineItems = a;
            delete subForm.includeDisabled; delete subForm.currency; delete subForm.area; delete subForm.city;
            delete subForm.state; delete subForm.country; delete subForm.netAmount; delete subForm.totalDiscount;
            delete subForm.business; delete subForm.partyGst; delete subForm.mop; delete subForm.pincode;
            delete subForm.customer; delete subForm.inAppStatus; delete subForm.createdBy; delete subForm.businessDocumentTemplates;
            delete subForm.updatedBy; delete subForm.createTs; delete subForm.updateTs; delete subForm.id; delete subForm.origin;
            delete subForm.cashDiscount; delete subForm.taxCode; delete subForm.tcsName;
            delete subForm.totalInvoiceAmount; delete subForm.isViaNotification; delete subForm.version; delete subForm.supplyOrderId; delete subForm.gstin;

            if (lines.length === subForm.salesOrderLineItems.filter(el => el.available_quantity === 0).length) {
                subForm.OrderStatus = 'DELIVERED';
            }

            a?.length > 0 && a?.map((element, i) => {
                element.lineStatus = 'DELIVERED';
                element.deliver_quantity = element.deliver_now;
                delete element.cgstAmount;
                delete element.discountCalcAmount;
                delete element.discountPercAmount;
                delete element.igstAmount;
                delete element.number;
                delete element.productUnitId;
                delete element.sgstAmount;
                delete element.useMrp;
                delete element.hsn;
                delete element.unit;
                delete element.product;
                delete element.productGst;
                delete element.productUnit;
                delete element.universalProduct;
                // element.lineNumber = (i + 1);
                return a.splice(i, 1, { ...element });
            });
            subForm.salesOrderLineItems = a;
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'v1/sales-order/sales-orders',
                title: 'Sales Order',
                id: form?.id,
                details: subForm
            });
        } else {
            setError({
                name: emptyName?.errors,
                stateId: emptyStateCheck?.errors,
                pincodeId: emptyPincode?.errors,
            });
        }
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
    };

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            setForm({
                ...data,
                validDate: data?.validDate ? dayjs(data?.validDate).$d : null,
                deliveryDate: data?.deliveryDate ? dayjs(data?.deliveryDate).$d : null,
                transactionDate: data?.transactionDate ? dayjs(data?.transactionDate).$d : null,
                comments: data?.comments || '',
                reference: data?.reference || '',
            });

            if (data?.stateId) {
                changeStateApi(data?.stateId);
            }

            if (data.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas',
                    filter: {
                        where: { ["and"]: [{ pincodeId: data.pincodeId }] }
                    }
                });
            }

            if (data?.salesOrderLineItems) {
                const newTodos = data?.salesOrderLineItems?.length > 0 ? data?.salesOrderLineItems?.filter((el) => el.available_quantity > 0).map((el) => {
                    return {
                        ...el,
                        'available_quantity': 0,
                        'duplicate_available_quantity': parseFloat(el.available_quantity),
                        'deliver_now': parseFloat(el.available_quantity)
                    };
                }) : [];
                setLines(newTodos);
                data?.salesOrderLineItems?.length > 0 && data?.salesOrderLineItems?.filter((el) => el.available_quantity > 0)?.map((el) => {
                    return selected.push(el.id);
                });
            }

            setTimeout(function () {
                dispatch({
                    type: qucikLinksActions.QUICKLINKS_START, menus: [], toggle: false,
                    factBox: '', component: "Sales Order"
                });
                childRef?.current?.handleAdjustHeight();
            }, 500)
        }
    }));

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const changeCountry = (value) => {
        let datas = {
            "areaId": "",
            "areaName": '',
            "pincodeId": "",
            "pincodeValue": '',
            "cityId": "",
            "cityName": '',
            "stateId": "",
            "stateName": '',
            "countryId": value?.id,
            "countryName": value?.name || '',
            "country": value,
            "currencyId": value.currencyId || ''
        };
        setForm({ ...form, ...datas });
    }

    const changeState = (value) => {
        let datas = {
            "areaId": '',
            "areaName": '',
            "pincodeId": '',
            "pincodeValue": '',
            "cityName": '',
            "cityId": '',
            "stateId": value.id,
            "state": value,
            "stateName": value?.name || '',
            "countryId": value?.countryId || '',
            "country": value?.country || '',
            "countryName": value?.country?.name || '',
            "currencyId": value?.country?.currencyId || '',
        };
        setForm({ ...form, ...datas });
        changeStateApi(value?.id);
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changeHandlerLine = (data, e, name = '') => {
        const newTodos = lines.map((el) => {
            if (el.id === data.id) {
                return { ...el, [name]: e, 'available_quantity': parseFloat(parseFloat(data.duplicate_available_quantity) - parseFloat(e)) };
            }
            return el;
        });
        setLines(newTodos);
    }

    const changeHandler = (e, name = '', relation = false) => {
        if (name !== '' && relation) {
            if (name === 'stateId') {
                changeState(e);
            } else if (name === 'countryId') {
                changeCountry(e);
            } else if (name === 'pincodeId') {
                changePincode(e);
            } else if (name === 'cityId') {
                setForm({
                    ...form,
                    "areaId": '',
                    "areaName": '',
                    "pincodeId": '',
                    "pincodeValue": '',
                    "cityName": e?.name,
                    "cityId": e?.id,
                    "city": e
                });
            } else if (name === 'areaId') {
                let datas = {
                    [name]: e.id,
                    areaName: e.name,
                    area: e
                };
                setForm({ ...form, ...datas });
            } else {
                setForm({
                    ...form,
                    [name]: e.id
                });
            }
            setError({
                ...error,
                [name]: false
            });
        } else if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
            setError({
                ...error,
                [name]: false
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });

            setError({
                ...error,
                [e.target.name]: false
            });
        }
    }

    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    }

    const changePincode = (value) => {
        let datas = {
            "areaId": '',
            "areaName": '',
            "pincodeId": value?.id,
            "pincode": value,
            "pincodeValue": value?.code || '',
            "cityId": value?.cityId || '',
            "city": value?.city || '',
            "cityName": value?.city?.name || '',
        };

        setForm({ ...form, ...datas });

        dispatch({
            type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                where: { ["and"]: [{ pincodeId: value?.id }] }
            }
        });
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setVisible(true);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            toast.error(text);
        }
    }, [editDetails, editError]);

    return (
        <Fragment>
            <CustomAccordion
                title={`Delivery Note`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={clsx(classes.tabWrapSubmit)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Sales Order', 'Page', 'Confirm') && selected?.length > 0 &&
                                            <Button
                                                tabIndex={-1}
                                                key="Save"
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                            >Confirm</Button>
                                        }
                                    </Space>
                                </div>
                                <DeliveryView {...props}
                                    error={error}
                                    customObject={(details, id) => customObject(details, id)}
                                    capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                    currencyFormat={(amount) => currencyFormat(amount)}
                                    changeHandler={(e, name = '', relation = false) => changeHandler(e, name, relation)}
                                    value={value}
                                    stateDetails={stateDetails}
                                    areaDetails={areaDetails}
                                    cityDetails={cityDetails}
                                    pincodeDetails={pincodeDetails}
                                    countryDetails={countryDetails}
                                    handleChange={(v) => handleChange(v)}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                    form={form} /></>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Delivery Note Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div > : <>
                                <DeliveryLinesList
                                    classes={classes}
                                    form={form}
                                    ref={formRef}
                                    type={type}
                                    idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                    currencyFormat={(amount) => currencyFormat(amount)}
                                    clsx={clsx}
                                    lines={lines}
                                    dispatch={dispatch}
                                    customObject={(details, id) => customObject(details, id)}
                                    getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                    headerView={view}
                                    roleManagement={roleManagement}
                                    selected={selected}
                                    handleClick={(data) => handleClick(data)}
                                    changeHandlerLine={(data, e, name = '') => changeHandlerLine(data, e, name)}
                                    checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                />
                            </>
                        }
                    </>
                }
            />

            <DeliveryChallan
                visible={visible}
                form={form}
                selected={selected}
                handleClose={() => history.push(`/sales/sales-management/sales-order/${orderId}/view`)}
                {...props}
            />
        </Fragment>
    )
})